function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Text, Flex } from '@tapresearch/ui/components';
export function CustomBarLabel(props) {
    var _answersById_barProps_bar_data_id;
    var answersById = props.answersById, barProps = props.barProps;
    if (!props.barProps) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Flex, {
        position: 'absolute',
        justify: 'space-between',
        px: 5,
        fontWeight: 'medium',
        color: 'gray.900',
        w: 'full',
        left: 0,
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        mt: '-1px'
    }, /*#__PURE__*/ React.createElement(Text, null, (_answersById_barProps_bar_data_id = answersById[barProps.bar.data.id]) === null || _answersById_barProps_bar_data_id === void 0 ? void 0 : _answersById_barProps_bar_data_id.option_text), /*#__PURE__*/ React.createElement(Text, null, barProps.bar.data.data[barProps.bar.data.id + '_total'], " (".concat(Number(barProps.bar.data.value).toFixed(2), "%)")));
}
export function getCustomBarLabel(param) {
    var answersById = param.answersById, usePercentage = param.usePercentage;
    // eslint-disable-next-line react/display-name
    return function(props) {
        return /*#__PURE__*/ React.createElement(CustomBarLabel, _object_spread_props(_object_spread({}, props), {
            answersById: answersById,
            usePercentage: usePercentage
        }));
    };
}
